import i18next from "i18next";
import { getNormalizedLanguageCode, SupportedLanguages } from "../../../libs/i18next/language";
import { Utilities } from "../../../utils/utilities";

export class TranslationData {
  fields: TranslationDataFields = {};
  standardLangCode: SupportedLanguages = SupportedLanguages.EN;

  constructor(fields: TranslationDataFields | undefined = undefined, standardLangCode: SupportedLanguages | undefined = undefined) {
    this.fields = fields ?? {};
    this.standardLangCode = standardLangCode ?? SupportedLanguages.EN;
  }

  updateField(fields: TranslationDataFields) {
    this.fields = fields;
    return this;
  }

  setup(data: any, standardLangCode: SupportedLanguages = SupportedLanguages.EN) {
    this.fields = {};
    this.standardLangCode = standardLangCode;
    if (Utilities.isValidObject(data)) {
      for (const key of Object.keys(data)) {
        this.fields[key] = data[key];
      }
    }

    return this;
  }

  translate(count?: number): string {
    const langId = getNormalizedLanguageCode(i18next.language);
    const codes = [langId, this.standardLangCode.code, "en", ...Object.keys(this.fields)];
    const priorities =
      count === undefined ? ["default", "singular", "plural"] : count > 1 ? ["plural", "default", "singular"] : ["singular", "default", "plural"];

    for (const code of codes) {
      for (const priority of priorities) {
        const codeData = this.fields[code];
        if (codeData) {
          if (priority === "default" && codeData.default) return codeData.default;
          if (priority === "singular" && codeData.singular) return codeData.singular;
          if (priority === "plural" && codeData.plural) return codeData.plural;
        }
      }
    }
    return "";
  }

  getRawData(): { [key: string]: any } {
    return this.fields;
  }

  static getTranslationData(data: any, standardLangCode: SupportedLanguages | undefined = undefined): TranslationData | undefined {
    if (data) {
      const translation = new TranslationData();
      translation.setup(data, standardLangCode ?? SupportedLanguages.EN);
      return translation;
    }
    return undefined;
  }
}

export type TranslationDataFields = {
  [key: string]: TranslationDataField;
};
export type TranslationDataField = {
  default?: string | null;
  singular?: string | null;
  plural?: string | null;
};

